import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getVisitAction } from "../../Actions/VisitAction/VisitAction";
import { getBranchAction } from "../../Actions/BranchAction/BranchAction";
import ComeBackFromDoctor from "./ComeBackFromDoctor";
import WhatsAppPage from "../WhatsAppPage/WhatsAppPage";
import MedicalSuplies from "../MedicalSupliesPage/MedicalSuplies";
import LoadingPage from "../Loading/LoadingPage";
import SendMediaInfo from "../WhatsAppPage/SendMediaInfo";

const SendInformation = ({ closeModal, patientId }) => {
  const dispatch = useDispatch();
  const [visit, setVisit] = useState([]);
  const [branchId, setBranchId] = useState(null);
  const [selectTypeInfo, setSelectTypeInfo] = useState(null);
  const getBranch = useSelector((state) => state.getBranch);
  const { branches } = getBranch;
  useEffect(() => {
    dispatch(getVisitAction(patientId));
    dispatch(getBranchAction());
  }, []);

  const getVisit = useSelector((state) => state.getVisit);
  const { visits, loading } = getVisit;
  const handleSelectVisit = (visit) => {
    setVisit(visit);
  };

  const typeOfHelpList = [];
  visit?.follow_up_commite?.map((commite) => {
    if (commite?.type_of_help?.length > typeOfHelpList.length) {
      commite?.type_of_help?.map((item) => {
        typeOfHelpList.push(item);
      });
    }
  });
  return (
    <React.Fragment>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="modal-overlay z-50">
          <div className="modal">
            <div className="modal-container lg:w-11/12">
              <div className="flex w-full items-center justify-between">
                <div
                  className="text-red-600 text-xl  cursor-pointer font-bold w-2/12"
                  onClick={closeModal}
                  title="Close"
                >
                  X
                </div>
                <div className="w-full flex gap-3">
                  {visit.id && (
                    <>
                      <div className="w-full">
                        <input
                          type="text"
                          value={typeOfHelpList}
                          className="input w-full"
                          name=""
                          id=""
                        />
                      </div>

                      <div className="w-full">
                        <select
                          name=""
                          value={branchId}
                          onChange={(e) => setBranchId(e.target.value)}
                          className="input  "
                          id=""
                        >
                          <option value="-1">Branch</option>
                          {branches?.map((branch, index) => {
                            return (
                              <option key={index} value={branch.id}>
                                {branch.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="w-full">
                        <select
                          name=""
                          onChange={(e) => setSelectTypeInfo(e.target.value)}
                          value={selectTypeInfo}
                          className="input  "
                          id=""
                        >
                          <option value="-1">Plese Choose Info</option>
                          <option value="1">گەڕانەوە لای دکتۆر</option>
                          <option value="2">ناردنی زانیاری</option>
                          <option value="3">ڕاگەیاندن</option>
                        </select>
                      </div>
                    </>
                  )}

                  <select
                    onChange={(e) =>
                      handleSelectVisit(JSON.parse(e.target.value))
                    }
                    name=""
                    className="input p-1 "
                    id=""
                  >
                    <option value="-1">Vists</option>
                    {visits?.map((visit, index) => {
                      return (
                        <option key={index} value={JSON.stringify(visit)}>
                          {visit.created_at.split("T")[0]}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>

              {selectTypeInfo == 1 ? (
                <ComeBackFromDoctor
                  branchId={branchId}
                  patientId={visit.patient_id}
                  visitId={visit.id}
                  comeBackDoctor={visit.come_back_doctor}
                />
              ) : selectTypeInfo == 3 ? (
                <SendMediaInfo
                  branchId={branchId}
                  mediaAllInfo={visit?.media_all_info_patient}
                  followUp={visit?.follow_up_commite}
                  mediaInformation={visit?.media_information}
                  visitId={visit.id}
                />
              ) : (
                ""
              )}

              {typeOfHelpList?.length > 0 &&
                typeOfHelpList.map((type, index) => {
                  return (
                    <React.Fragment key={index}>
                      {selectTypeInfo == 2 && type == "نەشتەرگەری" ? (
                        <WhatsAppPage
                          closeModal={closeModal}
                          branchId={branchId}
                          patientId={visit.patient_id}
                          visitId={visit.id}
                          visit={visit}
                        />
                      ) : (
                        ""
                      )}

                      {selectTypeInfo == 2 && type == "پێداویستی پزیشکی" ? (
                        <MedicalSuplies
                          visit={visit}
                          branchId={branchId}
                          patientId={visit.patient_id}
                          visitId={visit.id}
                          typeOfHelpList={typeOfHelpList}
                          closeModal={closeModal}
                        />
                      ) : (
                        ""
                      )}
                    </React.Fragment>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default SendInformation;
